module.exports = __webpack_public_path__ + "static/media/new_message.f0cb85b8.png";